<template>
  <div v-if="totalPages > 0">
    <page-container
      v-for="(page, idx) in totalPages"
      :key="`page_${page}`"
      :currentPage="page"
      :totalPages="totalPages"
      v-show="printMode || currentPage === page"
    >
      <section class="pdf-common-section">
        <div class="pdf-content-container">
          <i tabindex="0" hidefocus="true" id="pageTop" class="page-top-point"></i>
          <div class="pdf-header">
            <div class="pdf-title">
              <h2>{{ $locale("sideMenu.reports.AccountsReceivableVerify") }}</h2>
            </div>
            <div class="pdf-header-left">
              <div class="pdf-header-left-inner">
                <span>{{ $locale('pdfFilmFeeBalance.cinemasName') }}</span>
                <span>{{ pdfData.cinemaName }}</span>
              </div>
              <div class="pdf-header-left-inner">
                <span>{{ $locale('pdfFilmFeeBalance.targetYearMonth') }}</span>
                <span>{{ `${formatZoneDate(pdfData.monthDate)}` }}</span>
              </div>
            </div>
            <div class="pdf-header-right">
              <span>
                {{$locale("global.create")}}: {{ $moment(pdfData.exportAt).format("L LTS") }}
              </span>
              <span>
                Page: {{ page }} / {{ totalPages }}
              </span>
            </div>
          </div>

          <div class="pdf-listing-table">
            <item-list-table
              :pdfData="pageListData(page)"
              :header="tableHeader"
              :index="idx"
            ></item-list-table>
          </div>
        </div>
      </section>
    </page-container>
  </div>
</template>

<script>
import ItemListTable from "./ItemListTable";
import PageContainer from "@/components/Report/PdfPageContainer.vue";
import { toThousands } from "@/utils/common";
import { currencyFormatter } from "@/utils/filters";
import momentTz from "moment-timezone";

export default {
  name: "Accounts-Receivable-Verify-Pdf",
  components: {
    ItemListTable,
    PageContainer,
  },
  data() {
    return {
      tableHeader: [
        {
          label: this.$locale("verify.filmSearchId"),
          prop: "filmSearchId",
          width: 80,
          align: "center",
        },
        {
          label: this.$locale("global.titleOfWork"),
          prop: "filmName",
          width: 280,
          align: "left",
        },
        {
          label: this.$locale("verify.clientCode"),
          prop: "clientCode",
          width: 100,
          align: "center",
        },
        {
          label: this.$locale("accountPayable.customerName"),
          prop: "clientName",
          width: 260,
          align: "left",
        },
        {
          label: this.$locale("verify.ticketAmount"),
          prop: "ticketAmount",
          width: 100,
          align: "right",
          formatter: (row, column, cellValue) => {
            return currencyFormatter(cellValue);
          },
        },
        {
          label: this.$locale("accPayMDetail.requestAmount"),
          prop: "billingAmount",
          width: 100,
          align: "right",
          formatter: (row, column, cellValue) => {
            return currencyFormatter(cellValue);
          },
        },
        {
          label: this.$locale("accPayMDetail.difference"),
          prop: "differenceAmount",
          width: 100,
          align: "right",
          formatter: (row, column, cellValue) => {
            return currencyFormatter(cellValue);
          },
        },
      ],
      printMode: false,
      currentPage: 1,
      normalPageSize: 30,
      pageHeight: 600,
      pageListCounts: [],
    };
  },
  props: {
    pdfData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    tableData() {
      if(!this.pdfData.records) {
        return [];
      }
      const _data = this.formatTableData(this.pdfData);
      // this.formatTableNum(_data);
      return _data;
    },
    totalPages() {
      const _page = this.pageListCounts.length;
      return _page === 0 ? 1 : _page;
    }
  },
  watch: {
    pdfData() {
      // this.updatePdf();
      // this.tableData = this.formatTableData(this.pdfData);
      // this.formatTable();
      // update
      this.pageListCounts = [];
      this.setPrintMode(false);
      const vm = this;

      vm.$nextTick(() => {
        const _target = document.getElementById("listTable0");
        const _rows = _target.getElementsByClassName("el-table__row");
        let _pageCHeight = 0;

        _rows.forEach((__row, idx) => {
          _pageCHeight += __row.clientHeight;

          if (_pageCHeight >= this.pageHeight) {
            this.pageListCounts.push(idx);

            _pageCHeight = 0;
            _pageCHeight += __row.clientHeight;
          }
        });

        const _lastItem = this.pageListCounts[this.pageListCounts.length - 1];
        if (_lastItem !== _rows.length - 1) {
          this.pageListCounts.push(_rows.length);
        }

        this.setPrintMode(true);
        this.$emit("printPDF");
      });
    },
  },
  mounted() {
    // this.$moment.locale("ja");
    // after api call
    // this.updatePdf();
  },
  methods: {
    // updatePdf() {
    //   if(!this.$_.isEmpty(this.data)) {
    //     this.data.monthDate = this.$moment(Number(this.data.monthDate)).format("YYYY年MMM");
    //     this.data.exportAt = this.$moment(Number(this.data.exportAt)).format("L LTS");
    //     this.tableData = this.formatTableData(this.data);
    //     this.formatTableNum();
    //   }
    //   this.virtualPagination();
    // },
    formatTableData(_tableData) {
      const { allTotal, records } = _tableData;
      let _resultArray = [];

      records.forEach(_rcd => {
        const {
          filmSearchId,
          filmName,
          clientRecords,
        } = _rcd;
        let _filmSearchId = null;
        let _filmName = null;

        if (clientRecords.length === 0) {
          _resultArray.push({
            filmSearchId,
            filmName,
          });
        } else {
          clientRecords.forEach((_cRcd, idx) => {
            _filmSearchId = idx === 0 ? filmSearchId : "";
            _filmName = idx === 0 ? filmName : "";
            _resultArray.push({
              filmSearchId: _filmSearchId,
              filmName: _filmName,
              ..._cRcd,
            });
          });

          _filmSearchId = null;
          _filmName = null;
        }
      });

      const _totalData = {
        filmSearchId: this.$locale("global.total"),
        filmName: "",
        clientCode: "",
        clientName: "",
        ticketAmount: "",
        billingAmount: "",
        differenceAmount: allTotal,
        allTotal: true,
      };
      _resultArray.push(_totalData);
      return _resultArray;
    },
    tableDataCompare(prev, curr, prop) {
      return prev && prev[prop] === curr[prop] ? "" : curr[prop];
    },
    virtualPagination() {
      this.totalPages = Math.ceil((this.tableData.length - this.normalPageSize) / this.normalPageSize) + 1;
    },
    pageListData(page) {
      if (!this.tableData || this.tableData.length === 0) { return []; }

      let lists = [];

      if (this.printMode && this.pageListCounts.length > 0) {
        this.pageListCounts.forEach((_count, i) => {
          const startCount = page === 1 ? 0 : this.pageListCounts[page - 2];
          const size = _count;
          if (i + 1 > page || startCount > size) { return; }

          lists = [ ...this.tableData.slice(startCount, size) ];
        });

        return [ ...lists ];
      }
      return [ ...this.tableData ];
    },
    pageChangeAction(step) {
      this.currentPage += step;
      const pageTop = document.getElementById("pageTop");
      pageTop.focus();
    },
    setPrintMode(status) {
      this.currentPage = 1;
      this.printMode = status;
    },
    formatNum(value) {
      return value !== null && value.length !== 0 ? toThousands(value) : "";
    },
    formatTableNum(data) {
      data.forEach(item => {
        item.ticketAmount = this.formatNum(item.ticketAmount);
        item.billingAmount = this.formatNum(item.billingAmount);
        item.differenceAmount = this.formatNum(item.differenceAmount);
      });
    },
    formatZoneDate(timestamp) {
      return momentTz.tz(timestamp, "Asia/Tokyo").format("YYYY" + this.$locale("global.year") + "MM" + this.$locale("global.month"));
    }
  },
};
</script>

<style scoped lang="less">
  @import url("../../../assets/style/reportPdf.less");
</style>